import cx from 'classnames';
import { useFormikContext } from 'formik';
import React, { useCallback, useState } from 'react';
import bt from '../bootstrap.module.css';
import FormElementWrapper from '../components/FormElementWrapper';
import InlineEdit from '../components/InlineEdit';
import ObligationSource from '../components/ObligationSource';
import useGetFormGeneratorItemError from '../hooks/useGetFormGeneratorItemError';

const SingleChoice = props => {
  const { isBuilder, data, onChange, value, disabled, readOnly } = props;
  const { options, id, label } = data;
  const { requiredError } = useGetFormGeneratorItemError(id);
  const [isEditing, setIsEditing] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const index = values?.data?.findIndex(({ id }) => id === props.data.id);

  const handleSelect = useCallback(
    optionId => onChange(data.type, id, optionId),
    [onChange, data.type, id],
  );

  const handleLabelChange = e => {
    const { name, value } = e.target;
    setFieldValue(`data[${index}].${name}`, value);
  };

  return (
    <FormElementWrapper {...props} onClick={!readOnly ? () => setIsEditing(true) : undefined}>
      <div className={cx['form-group']}>
        <div className="font-semibold">
          <InlineEdit
            value={label}
            onChange={handleLabelChange}
            fieldName="label"
            isEditing={isEditing}
            onSetIsEditing={setIsEditing}
            readOnly={readOnly}
          />
        </div>
        {data.compliance && <ObligationSource source={data.obligationSource} />}

        {(options || []).map(option => {
          const this_key = option.id;
          const props = {
            type: 'radio',
            value: option.id,
            disabled: isBuilder || disabled,
          };
          // props.name = props.data.field_name;

          if (props.mutable) {
            props.defaultChecked =
              props.defaultValue !== undefined &&
              (props.defaultValue.indexOf(option.id) > -1 ||
                props.defaultValue.indexOf(option.value) > -1);
          }
          const id = `${isBuilder ? 'builder_' : ''}fid_${this_key}`;
          return (
            <div className={cx(bt['custom-control'], bt['custom-radio'])} key={this_key}>
              <input
                id={id}
                className={bt['custom-control-input']}
                checked={value === option.id}
                onChange={handleSelect.bind(null, option.id)}
                {...props}
              />
              <label
                className={cx(bt['custom-control-label'], {
                  'cursor-pointer': !disabled,
                })}
                htmlFor={id}
                style={{ marginBottom: 8 }}
              >
                {option.label}
              </label>
            </div>
          );
        })}
        {requiredError && <div style={{ color: 'red', marginTop: 4 }}>This field is required</div>}
      </div>
    </FormElementWrapper>
  );
};

export default SingleChoice;
